export default {
    /* eslint-disable global-require */
    darkLogo: require("./cv-logo-dark.png"),
    lightLogo: require("./cv-logo-light.png"),
    uVerifiLogoDark: require("./uverifi-logo-dark.png"),
    uVerifiLogoLight: require("./uverifi-logo-light.png"),
    overlay: {
        identifier: require("./overlay-identifier.png"),
    },
    /* eslint-enable global-require */
};
